import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 8,
	viewBox: "0 0 10 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.160156 2.12625L1.37234 0.914063L5.05196 4.59369L8.73158 0.914063L9.94377 2.12625L5.05196 7.01805L0.160156 2.12625Z",
		fill: "#828599"
	})]
});
const ForwardRef = forwardRef(SvgDownArrow);
export default ForwardRef;
